import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// import getSymbolFromCurrency from "currency-symbol-map";
import { CartModal, CartTimer } from "@components";
import { updateCart } from "@redux/booking/slice";
import ShoppingCartRoundedIcon from "@mui/icons-material/ShoppingCartRounded";
import "../../App.css";
import theme from "../../theme";

export default function CartsView() {
  const dispatch = useDispatch();
  const { cartDetails } = useSelector((store) => store.bookingReducer);
  const { setting } = useSelector((store) => store.settingsReducer);
  const cartTimer = setting?.data?.checkoutTimer;

  const [countDownTime, setCountDownTime] = useState(cartTimer * 60);
  const [showTimer, setShowTimer] = useState(false);
  const [state, setState] = useState({
    cartModal: false,
    totalSelectedClub: 0,
  });

  // const prices =
  //   cartDetails && cartDetails?.length > 0
  //     ? cartDetails.map((a) => a?.amount)
  //     : "";
  // const totalPrice =
  //   cartDetails && cartDetails?.length > 0 && prices
  //     ? prices.reduce((acc, curr) => acc + curr)
  //     : "";

  // let currencyType = cartDetails?.length > 0 ? cartDetails[0]?.currency : "EUR";
  // let currencySymble =
  //   currencyType?.length > 1
  //     ? getSymbolFromCurrency(currencyType)
  //     : currencyType;

  const closeModal = () => {
    setState((prev) => ({ ...prev, cartModal: false }));
  };

  useEffect(() => {
    let localdata = JSON.parse(localStorage.getItem("C2H_LocalCartData"));
    if (localdata?.length && !cartDetails?.length) {
      dispatch(updateCart({ localdata: localdata, localSave: true }));
    }

    if (cartDetails?.length > 0) {
      localStorage.setItem("GolfCartStartTime", Date.now().toString());
      // setCountDownTime(cartTimer * 60);
      setShowTimer(true);

      let mergedMap = {};
      cartDetails.forEach((item) => {
        if (!mergedMap[`${item.clubId}-${item.courseId.courseId}`]) {
          mergedMap[`${item.clubId}-${item.courseId.courseId}`] = {
            ...item,
          };
        } else {
          mergedMap[`${item.clubId}-${item.courseId.courseId}`].players +=
            item.players;
        }
      });

      let updated_CartDetail = Object.values(mergedMap);
      setState((prev) => ({
        ...prev,
        totalSelectedClub: updated_CartDetail.length,
      }));
    }
  }, [cartDetails]);

  useEffect(() => {
    const storedStartTime = localStorage.getItem("GolfCartStartTime");

    if (storedStartTime) {
      const elapsedTime = Math.floor(
        (Date.now() - parseInt(storedStartTime, 10)) / 1000
      );
      const remainingTime = Math.max(cartTimer * 60 - elapsedTime, 0);

      // setCountDownTime(remainingTime);

      if (remainingTime === 0) {
        remove_AllItems();
        localStorage.removeItem("GolfCartStartTime");
      } else {
        setShowTimer(true);
      }
    } else {
      localStorage.setItem("GolfCartStartTime", Date.now().toString());
      setShowTimer(true);
    }
  }, []);

  useEffect(() => {
    if (countDownTime <= 0) {
      remove_AllItems();
      setShowTimer(false);
      localStorage.removeItem("GolfCartStartTime");
      return;
    }

    const interval = setInterval(() => {
      // setCountDownTime((prevTime) => prevTime - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [countDownTime]);

  const remove_AllItems = () => {
    if (window.location.pathname !== "/checkout") {
      dispatch(updateCart({ removeItem: true }));
      closeModal();
    }
  };

  return (
    <>
      {cartDetails?.length > 0 ? (
        <div
          onClick={() => setState((prev) => ({ ...prev, cartModal: true }))}
          className="w-auto h-[40px] rounded-full bg-buttonColor flex flex-row items-center xl:justify-around justify-center md:gap-x-2 gap-x-1 md:px-4 px-2 hover:cursor-pointer hover:opacity-80"
        >
          {window.location.pathname !== "/checkout" && (
            <div className="w-[90px]">
              <CartTimer />
            </div>
          )}
          <div className="w-[20px] h-[20px] mb-1">
            <ShoppingCartRoundedIcon sx={{ color: theme.colors.whiteText }} />
          </div>
          <div className="w-auto min-w-[25px] px-[8px] flex items-center justify-center h-auto bg-white border border-black rounded-full">
            <span className="text-[16px] font-semibold text-center">
              {state.totalSelectedClub}
            </span>
          </div>
          {/* <div>
            <sup className="font-black text-whiteText lg:text-[11px] text-[9px]">
              {currencySymble}
            </sup>
            <span className="text-[16px] text-whiteText font-black">
              {Math.round(totalPrice)}
            </span>
          </div> */}
        </div>
      ) : (
        <></>
      )}
      <CartModal
        openModal={state.cartModal}
        closeModal={closeModal}
        addToCartData={cartDetails}
        showTimer={showTimer}
        removeAllItems={remove_AllItems}
      />
    </>
  );
}
